import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IProps {
  theme: any;
  isActive?: boolean;
}
export const Wrapper = styled.div<IProps>`
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: ${rem(8)};
  padding: ${rem(8)} ${rem(10)};
  font-size: ${rem(14)};
  -webkit-tap-highlight-color: transparent;
  ${({ isActive, theme}) =>
    isActive
      ? `
        background: ${theme.color['gray-800']};
        color: ${theme.color.white};
        border: 1px solid ${theme.color.white};
      `:`
        background: ${theme.color.white};
        color: ${theme.color['gray-400']};
        border: 1px solid ${theme.color['gray-100']};
      `}
  ${({ theme }) => theme.media.fold`
    padding: ${rem(7)} ${rem(9)};
    font-size: ${rem(12)};
  `};
`;



